<script setup lang="ts">
import { setup, type Props } from './trendChartCell.setup';

const props = withDefaults(defineProps<Props>(), {
  useFlex: false,
  metricValueWidth: 36,
});

const { chartData, chartOption, currentValue, metricValueWidthPx } = setup(props);
</script>

<template>
  <div
    class="trend-chart-cell"
    :class="{ 'trend-chart-cell--flex': props.useFlex }"
  >
    <div class="chart-wrapper">
      <ev-chart
        :data="chartData"
        :options="chartOption"
      />
    </div>
    <span
      class="metric-value"
      :title="currentValue?.toString() ?? ''"
      >{{ currentValue }}</span
    >
  </div>
</template>

<style scoped lang="scss">
.trend-chart-cell {
  width: 100%;
  height: 100%;
}

.chart-wrapper {
  display: inline-block;
  width: calc(100% - v-bind('metricValueWidthPx'));
  height: 100%;
  vertical-align: middle;
}
.metric-value {
  display: inline-block;
  min-width: v-bind('metricValueWidthPx');
  max-width: v-bind('metricValueWidthPx');
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.trend-chart-cell--flex {
  display: flex;
  align-items: center;

  .chart-wrapper {
    flex: 3 1 0;
    width: auto;
    min-width: 0;
  }
  .metric-value {
    flex: 1 1 v-bind('metricValueWidthPx');
    min-width: 0;
    max-width: none;
    padding-left: 4px;
  }
}
</style>

<style lang="scss">
.trend-chart-cell-tooltip {
  padding: 12px;

  &__header {
    font-size: 12px;
    font-weight: 700;
    color: var(--color-gray-00-12);
  }

  &__body {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
  }

  &__label {
    display: inline-flex;
    align-items: center;
    color: var(--color-gray-00-12);
  }

  &__dot {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    margin-right: 6px;
    border-radius: 50%;
  }

  &__value {
    font-weight: 500;
    color: var(--color-gray-01-11);
    white-space: nowrap;
  }

  &__footer {
    margin-top: 8px;
    opacity: 0.6;
    font-size: 11px;
    color: var(--color-gray-00-12);
  }
}
</style>

<style lang="scss">
/* evui 툴팁은 teleport되므로 비scoped 전역 스타일로 스타일링 */
.trend-chart-cell__tooltip {
  width: 220px;
}
.trend-chart-cell__tooltip .trend-chart-cell__tooltip-desc {
  padding: 4px 8px;
  font-size: 11px;
  line-height: 1.4;
  color: var(--color-gray-02-10);
  white-space: normal;
}
</style>
